export class Firmware {
	constructor(		
		public nombre: string,
		public version: string,
		public ip: string,
		public puerto: number,
	) {}
}